import { Dialog as FluentDialog } from "@fluentui/web-components";
/**
 * Dialog
 * @summary A Dialog Custom HTML Element that provides modal, non-modal, and alert dialog types with accessible attributes.
 *
 * @example
 * ```html
 * <fabric-dialog type="modal" aria-labelledby="dialog-label" aria-describedby="dialog-desc">
 *   <span slot="title">Title</span>
 *   <div>Content of the dialog body</div>
 *   <span slot="action">Action buttons</span>
 * </fabric-dialog>
 * ```
 *
 * @attr {string} aria-describedby - Identifies the element (or elements) that describes the object.
 * @attr {string} aria-labelledby - Identifies the element (or elements) that labels the current element.
 * @attr {DialogType} type - The type of dialog ('modal', 'non-modal', 'alert').
 *
 * @prop {HTMLElement} dialog - The internal dialog element reference.
 * @prop {string} ariaDescribedby - Reflects the 'aria-describedby' attribute to associate the dialog with descriptive text.
 * @prop {string} ariaLabelledby - Reflects the 'aria-labelledby' attribute to associate the dialog with its label.
 * @prop {DialogType} type - The type of dialog, which can be 'modal', 'non-modal', or 'alert'.
 *
 * @slot - The default slot for dialog content.
 *
 * @csspart dialog - The dialog container.
 *
 * @method show() - Opens the dialog.
 * @method hide() - Closes the dialog.
 * @method clickHandler() - Handles click events on the dialog.
 *
 * @fires {CustomEvent} beforetoggle - Event emitted before the dialog's open state changes.
 * @fires {CustomEvent} toggle - Event emitted after the dialog's open state changes.
 *
 * @extends FluentDialog
 * @tagname fabric-dialog
 * @public
 */
export class Dialog extends FluentDialog {
}
//# sourceMappingURL=dialog.js.map